import { useState } from "react";
import { Link } from "react-router-dom";
import { useAccount } from "../../context/AccountContext";
import { useAuth } from "../../context/AuthContext";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import { UserAvatar } from "./UserAvatar";

export const UserMenu = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { account } = useAccount();
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Dropdown
      show={showDropdown}
      onToggle={(isOpen) => setShowDropdown(isOpen)}
      align="end"
      className="user-dropdown-toggle"
    >
      <Dropdown.Toggle
        as="div"
        id="user-dropdown"
        className="d-flex align-items-center cursor-pointer"
      >
        <UserAvatar account={account} showName={false} size={42} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="user-menu border shadow-sm p-0 mt-2">
        <div className="user-menu__header d-flex align-items-center p-3">
          <UserAvatar account={account} showName={true} size={38} />
        </div>
        <div className="p-2">
          <Dropdown.Item
            as={Link}
            to="/settings/account"
            className="user-menu__item d-flex align-items-center gap-2 rounded-2 py-2"
          >
            <i className="bi bi-gear text-secondary"></i>
            <span>{t("sidebar.menu.settings.account")}</span>
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to="/spaces"
            className="user-menu__item d-flex align-items-center gap-2 rounded-2 py-2"
          >
            <i className="bi bi-grid text-secondary"></i>
            <span>{t("spaces.title")}</span>
          </Dropdown.Item>
        </div>
        <div className="user-menu__section p-2">
          <Dropdown.Item
            onClick={logout}
            className="user-menu__item d-flex align-items-center gap-2 rounded-2 py-2"
          >
            <i className="bi bi-box-arrow-right text-danger"></i>
            <span>{t("sidebar.menu.logout")}</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
